import * as React from 'react';

function StarIcon({ 'aria-hidden': ariaHidden = true, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="o1htafl7ca"
          d="M12.967 15.833c-.134 0-.265-.03-.384-.091l-4.25-2.225-4.25 2.225c-.281.148-.623.123-.88-.065-.256-.188-.384-.505-.328-.819l.833-4.691L.275 6.833C.057 6.616-.023 6.295.067 6c.098-.302.36-.522.675-.567l4.75-.691L7.583.467c.14-.288.43-.47.75-.47s.611.182.75.47L11.2 4.733l4.75.692c.315.045.576.265.675.567.09.295.01.615-.208.833l-3.434 3.333.834 4.692c.06.319-.07.644-.334.833-.15.106-.332.159-.516.15z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0H20V20H0z"
                  transform="translate(-228 -174) translate(155 170) translate(65) translate(8 4)"
                />
                <g transform="translate(-228 -174) translate(155 170) translate(65) translate(8 4) translate(1.667 1.667)">
                  <mask id="be3drm2hdb" fill="#fff">
                    <use xlinkHref="#o1htafl7ca" />
                  </mask>
                  <use fill="#000" fillRule="nonzero" xlinkHref="#o1htafl7ca" />
                  <g fill={props.fill ? props.fill : '#383C52'} mask="url(#be3drm2hdb)">
                    <path d="M0 0H20V20H0z" transform="translate(-1.667 -1.667)" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default StarIcon;
